import React, { forwardRef } from 'react';
import InputDropdown, { IInputDropdownProps } from 'component-library/atoms/InputDropdown/InputDropdown';

type TWithoutOptions = Omit<IInputDropdownProps, 'options'>;
export interface IInputDropdownStateProps extends TWithoutOptions {
	abbreviation?: boolean;
	mixed?: boolean;
}

const optionsResolver = (abbreviation: boolean, mixed: boolean) => {
    if (abbreviation) {
        return [
            'AL',
            'AK',
            'AS',
            'AZ',
            'AR',
            'AE',
            'AA',
            'AP',
            'CA',
            'CO',
            'CT',
            'DC',
            'DE',
            'FM',
            'FL',
            'GA',
            'GU',
            'HI',
            'ID',
            'IL',
            'IN',
            'IA',
            'KS',
            'KY',
            'LA',
            'ME',
            'MH',
            'MD',
            'MA',
            'MI',
            'MN',
            'MS',
            'MO',
            'MT',
            'NE',
            'NV',
            'NH',
            'NJ',
            'NM',
            'NY',
            'NC',
            'ND',
            'MP',
            'OH',
            'OK',
            'OR',
            'PW',
            'PA',
            'PR',
            'RI',
            'SC',
            'SD',
            'TN',
            'TX',
            'UT',
            'VT',
            'VI',
            'VA',
            'WA',
            'WV',
            'WI',
            'WY',
        ];
    }

    if (mixed) {
        return [
            { option: 'Alabama', value: 'AL' },
            { option: 'Alaska', value: 'AK' },
            { option: 'Arizona', value: 'AZ' },
            { option: 'Arkansas', value: 'AR' },
            { option: 'California', value: 'CA' },
            { option: 'Colorado', value: 'CO' },
            { option: 'Connecticut', value: 'CT' },
            { option: 'DC - Washington DC', value: 'DC' },
            { option: 'Delaware', value: 'DE' },
            { option: 'Florida', value: 'FL' },
            { option: 'Georgia', value: 'GA' },
            { option: 'Hawaii', value: 'HI' },
            { option: 'Idaho', value: 'ID' },
            { option: 'Illinois', value: 'IL' },
            { option: 'Indiana', value: 'IN' },
            { option: 'Iowa', value: 'IA' },
            { option: 'Kansas', value: 'KS' },
            { option: 'Kentucky', value: 'KY' },
            { option: 'Louisiana', value: 'LA' },
            { option: 'Maine', value: 'ME' },
            { option: 'Maryland', value: 'MD' },
            { option: 'Massachusetts', value: 'MA' },
            { option: 'Michigan', value: 'MI' },
            { option: 'Minnesota', value: 'MN' },
            { option: 'Mississippi', value: 'MS' },
            { option: 'Missouri', value: 'MO' },
            { option: 'Montana', value: 'MT' },
            { option: 'Nebraska', value: 'NE' },
            { option: 'Nevada', value: 'NV' },
            { option: 'New Hampshire', value: 'NH' },
            { option: 'New Jersey', value: 'NJ' },
            { option: 'New Mexico', value: 'NM' },
            { option: 'New York', value: 'NY' },
            { option: 'North Carolina', value: 'NC' },
            { option: 'North Dakota', value: 'ND' },
            { option: 'Ohio', value: 'OH' },
            { option: 'Oklahoma', value: 'OK' },
            { option: 'Oregon', value: 'OR' },
            { option: 'Pennsylvania', value: 'PA' },
            { option: 'Rhode Island', value: 'RI' },
            { option: 'South Carolina', value: 'SC' },
            { option: 'South Dakota', value: 'SD' },
            { option: 'Tennessee', value: 'TN' },
            { option: 'Texas', value: 'TX' },
            { option: 'Utah', value: 'UT' },
            { option: 'Vermont', value: 'VT' },
            { option: 'Virginia', value: 'VA' },
            { option: 'Washington', value: 'WA' },
            { option: 'West Virginia', value: 'WV' },
            { option: 'Wisconsin', value: 'WI' },
            { option: 'Wyoming', value: 'WY' },
        ];
    }

    return [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'DC - Washington DC',
        'Delaware',
        'Florida',
        'Georgia',
        'Guam',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming',
    ];
};

const InputDropdownState = forwardRef(
    (
        {
            className,
            placeholder,
            abbreviation = false,
            mixed = false,
            invalidErrorMessage = 'Please provide a valid State',
            resetToggle,
            ...rest
        }: IInputDropdownStateProps,
        ref,
    ) => {
        return (
            <InputDropdown
                aria-label='State'
                className={`InputDropdownState ${className || ''}`}
                ref={ref}
                placeholder={placeholder}
                options={optionsResolver(abbreviation, mixed)}
                invalidErrorMessage={invalidErrorMessage}
                {...rest}
                data-cl={15}
                resetToggle={resetToggle}
            />
        );
    },
);

InputDropdownState.displayName = 'InputDropdownState';

export default InputDropdownState;
